import React, { useState } from 'react';
import '../CSS/style/style.css';

const images = [
    { seq: 4,  img: 'Gallery4.jpeg'  },
    { seq: 5,  img: 'Gallery5.jpeg'  },
    { seq: 6,  img: 'Gallery6.jpeg'  },
    { seq: 7,  img: 'Gallery7.jpeg'  },
    { seq: 8,  img: 'Gallery8.jpeg'  },
    { seq: 10, img: 'Gallery10.jpeg' },
    { seq: 12, img: 'Gallery12.jpeg' },
    { seq: 13, img: 'Gallery13.jpeg' },
    { seq: 14, img: 'Gallery14.jpeg' },
    { seq: 15, img: 'Gallery15.jpeg' },
    { seq: 16, img: 'Gallery16.jpeg' },
    { seq: 17, img: 'Gallery17.jpeg' },
    { seq: 19, img: 'Gallery19.jpeg' },
    { seq: 20, img: 'Gallery20.jpeg' },
    { seq: 21, img: 'Gallery21.jpeg' },
    { seq: 22, img: 'Gallery22.jpeg' },
    { seq: 33, img: 'Gallery33.jpeg' },
];

const Gallery = () => {
    const [lightbox, setLightbox] = useState(null);

    return (
        <div className="main-wrapper">
            <section className="foot-banner"></section>

            <div className="main-container">
                <div className="section-header">
                    <span className="section-label">GALLERY</span>
                    <h2 className="section-title">펜션 갤러리</h2>
                </div>

                <div className="gallery-grid">
                    {images.map(({ seq, img }) => (
                        <div
                            key={seq}
                            className="gallery-card"
                            onClick={() => setLightbox(`/resource/Gallery/${img}`)}
                        >
                            <img
                                src={`/resource/Gallery/${img}`}
                                alt={`Gallery ${seq}`}
                                className="gallery-thumb"
                            />
                        </div>
                    ))}
                </div>
            </div>

            {lightbox && (
                <div className="lightbox" onClick={() => setLightbox(null)}>
                    <button className="lightbox-close" onClick={() => setLightbox(null)}>✕</button>
                    <img src={lightbox} alt="확대 이미지" className="lightbox-img" />
                </div>
            )}
        </div>
    );
};

export default Gallery;